//@ts-nocheck
import { Fragment, useEffect, useRef, useState } from "react";
import { Menu, Switch, Transition } from "@headlessui/react";
import { useAppDispatch } from "../../app/hooks";
import { createTeamsPayload } from "../../features/jobActions/JobActionTypes";
import { toast } from "sonner";
import {
  createLocation,
  fetchScoreCardList,
  updateLocation,
} from "../../features/jobActions/JobActionSlice";
import { ChevronDownIconWhite, CustomCheckIcon } from "../../components/icons";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/react";
import { fetchScoreCardPipelineDetailsData } from "../../features/scorecard/scoreCardSlice";
import { useParams } from "react-router-dom";
import { fetchQuestionJobData } from "../../features/questionnaire/questionnaireSlice";
import { fetchReviewListByJobId } from "../../features/review/reviewSlice";
import { Dialog } from "@headlessui/react";
import { CrossIcon } from "../icons/Icons";
import { fetchJobPipelineDetailsData } from "../../features/hiringpipeline/hiringPipelineSlice";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSave?: (e: any) => void;
  loading?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onSave,
  loading,
}) => {
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-4 overflow-visible max-h-[750px]">
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon />
                  </button>
                </div>
                <div className="sm:flex sm:items-start w-full">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                    <Dialog.Title
                      as="h3"
                      className="text-base font-semibold leading-6 text-gray-900 capitalize"
                    >
                      {title}
                    </Dialog.Title>
                    <div className="mt-4">{children}</div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
                  <button
                    type="button"
                    className=" inline-flex shrink-0  justify-center items-center gap-1 rounded-md bg-indigo-600 px-[14px] py-1 h-[32px] text-[13px] font-medium leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    disabled={loading}
                    onClick={onSave}
                  >
                    Save
                    {loading && (
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    )}
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center items-center rounded-md bg-white px-[14px] py-2 text-[13px] h-[32px] font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

interface BoardPageProps {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  editBoardData?: any;
  baseId: number;
  setEditBoardData: (value: any) => void;
  pipelineStageData: any[];
  setPipelineStageData: (value: any) => void;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const CreateJobActionCard: React.FC<BoardPageProps> = ({
  isModalOpen,
  setIsModalOpen,
  editBoardData,
  setEditBoardData,
  setBoardsFetched,
  pipelineStageData,
  setPipelineStageData,
}) => {
  const [name, setName] = useState("");
  const [purpose, setPurpose] = useState("");
  const [color, setColor] = useState("bg-[#3b82f6]");
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nameError, setNameError] = useState("");
  const [purposeError, setPurposeError] = useState("");
  const dispatch = useAppDispatch();
  const userStatus = localStorage.getItem("userDetails");
  const userStatusId = userStatus ? JSON.parse(userStatus) : null;
  const [isOpenHeader, setIsOpenHeader] = useState(true);
  const optionsWithAllStagesHeader = [...pipelineStageData];
  const [selectedStage, setSelectedStage] = useState(
    pipelineStageData?.[0] || null,
  );
  const jobTypeOptions = [
    // { id: 1, name: 'scorecard' },
    { id: 2, name: "questionnaire" },
    { id: 3, name: "review" },
    { id: 4, name: "evaluation" },
  ];
  const [selectedJobType, setSelectedJobType] = useState(jobTypeOptions[0]);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();

  // score card
  const [jobScoreCardData, setJobScoreCardData] = useState([]);
  const [selectedScoreCard, setSelectedScoreCard] = useState(
    jobScoreCardData?.[0] || null,
  );
  const optionsWithAllScoreCardHeader = [...jobScoreCardData];

  // questionnaire
  const [jobQuestionnaireData, setJobQuestionnaireData] = useState([]);
  const [selectedQuestionnaire, setSelectedQuestionnaire] = useState(
    jobQuestionnaireData?.[0] || null,
  );
  const optionsWithAllQuestionnaireHeader = [...jobQuestionnaireData];

  // meeting
  const [jobReviewData, setJobReviewData] = useState([]);
  const [selectedReview, setSelectedReview] = useState(
    jobReviewData?.[0] || null,
  );
  const optionsWithAllReviewHeader = [...jobReviewData];

  // assign to
  const [jobAssignData, setJobAssignData] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];

  const aiOption = {
    id: "0",
    user_id: "ai",
    name: "AI",
    is_ai: true,
  };

  const optionsWithAllAssignHeader = [aiOption, ...jobAssignData];

  const [isAssignListOpen, setIsAssignListOpen] = useState(false);

  const colorList = [
    { name: "bg-[#3b82f6]" },
    { name: "bg-[#6b7280]" },
    { name: "bg-[#bfdbfe]" },
    { name: "bg-[#ec4899]" },
    { name: "bg-[#6366f1]" },
    { name: "bg-[#eab308]" },
    { name: "bg-[#22c55e]" },
    { name: "bg-[#06b6d4]" },
    { name: "bg-[#dc2626]" },
  ];

  // Load edit data when available
  // Load edit data when available
  useEffect(() => {
    if (editBoardData) {
      // Set color
      setColor(`bg-[${editBoardData.action_colour}]`);

      // Set selected stage
      setSelectedStage(
        pipelineStageData.find((stage) => stage.id == editBoardData.trigger_id),
      );

      // Set job type
      const jobType =
        jobTypeOptions.find(
          (type) => type.name === editBoardData.action_type,
        ) || jobTypeOptions[0];
      setSelectedJobType(jobType);

      // Handle type-specific data based on action_type
      if (
        editBoardData.action_type === "scorecard" &&
        jobScoreCardData.length > 0
      ) {
        const scorecard = jobScoreCardData.find(
          (score) => score.id == editBoardData.action_type_id,
        );
        if (scorecard) setSelectedScoreCard(scorecard);
      } else if (
        editBoardData.action_type === "questionnaire" &&
        jobQuestionnaireData.length > 0
      ) {
        const questionnaire = jobQuestionnaireData.find(
          (question) => question.id == editBoardData.action_type_id,
        );
        if (questionnaire) setSelectedQuestionnaire(questionnaire);
      } else if (
        editBoardData.action_type === "review" &&
        jobReviewData.length > 0
      ) {
        const review = jobReviewData.find(
          (rev) => rev.id == editBoardData.action_type_id,
        );
        if (review) setSelectedReview(review);
      }

      // Handle assignees if they exist
      if (editBoardData.assign_to) {
        const assignIds = editBoardData.assign_to
          .split(",")
          .map((id) => id.trim());

        const assignees = [...jobAssignData, aiOption].filter((member) => {
          // Add null check before calling toString()
          if (member.user_id === "ai" && assignIds.includes("0")) {
            return true;
          }
          // Add null check before calling toString()
          if (member.user_id === null || member.user_id === undefined) {
            return false;
          }
          return assignIds.includes(member.user_id.toString());
        });
        setSelectedAssignees(assignees);
      } else {
        setSelectedAssignees([]);
      }
    }
  }, [
    editBoardData,
    pipelineStageData,
    jobScoreCardData,
    jobQuestionnaireData,
    jobReviewData,
    jobAssignData,
  ]);

  const handleSave = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    const privacy = checked ? "yes" : "no";
    const colorValue = color.substring(
      color.indexOf("[#") + 1,
      color.indexOf("]"),
    );
    // Format the assign_to as a comma-separated string instead of an array
    const assignToValue =
      selectedAssignees.length > 0
        ? selectedAssignees
            .map((a) => {
              // Replace 'ai' with '0' for the AI option
              if (a.user_id === "ai" || a.is_ai) {
                return "0";
              }
              // Otherwise use the user_id or id
              return a.user_id || a.id;
            })
            .join(",")
        : null;

    const getActionTypeId = () => {
      switch (selectedJobType.name) {
        // case 'scorecard':
        //   return selectedScoreCard?.id;
        case "questionnaire":
          return selectedQuestionnaire?.id;
        case "review":
          return selectedReview?.id;
        default:
          return null;
      }
    };

    const payload: createTeamsPayload = {
      base_id: baseId,
      job_id: jobId,
      trigger: "stage",
      assign_to: assignToValue,
      trigger_id: selectedStage?.id,
      action_colour: colorValue,
      action_type: selectedJobType.name,
      action_type_id: getActionTypeId(),
    };

    try {
      if (editBoardData) {
        // Update existing team
        const response = await dispatch(
          updateLocation({
            payload,
            baseId: baseId,
            id: editBoardData.id,
          }),
        );

        if (response.meta.requestStatus === "fulfilled") {
          setIsModalOpen(false);
          const baseResponse = await dispatch(
            fetchScoreCardList({
              baseId: Number(baseId),
              jobId,
            }),
          );
          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "jobActionData",
              JSON.stringify(baseResponse.payload),
            );
          } else {
            setBoardsFetched([]);
          }

          toast.success("Actions updated successfully!");
        } else {
          toast.error("Failed to update actions.");
        }
      } else {
        // Create new team
        const response = await dispatch(
          createLocation({ payload, userId: baseId }),
        );
        if (response.meta.requestStatus === "fulfilled") {
          setIsModalOpen(false);
          resetForm();
          toast.success("Actions created successfully!");
          const baseResponse = await dispatch(
            fetchScoreCardList({
              baseId: Number(baseId),
              jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "jobActionData",
              JSON.stringify(baseResponse.payload),
            );
          } else {
            setBoardsFetched([]);
          }
        } else {
          toast.error("Failed to create action.");
        }
      }
    } catch (error) {
      console.error("Failed to save team:", error);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setColor("bg-[#3b82f6]");
    setSelectedStage(pipelineStageData?.[0] || null);
    setSelectedJobType(jobTypeOptions[0]);
    setSelectedScoreCard(null);
    setSelectedQuestionnaire(null);
    setSelectedReview(null);
    setSelectedAssignees([]);
    setEditBoardData(null);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "name") {
      setName(value);
      setNameError(value.trim().length === 0 ? "Name is required" : "");
    } else if (name === "purpose") {
      setPurpose(value);
      // setPurposeError(value.trim().length === 0 ? "Description is required" : "");
    }
  };

  const handleToggleHeader = () => {
    setIsOpenHeader(!isOpenHeader);
  };

  // job scorecard
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseScoreCardDataByJob");
        if (storedBase) {
          let data = JSON.parse(storedBase);
          setJobScoreCardData(data.data);
        } else {
          try {
            const baseResponse = await dispatch(
              fetchScoreCardPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            );
            setJobScoreCardData(baseResponse.payload.data);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  // job questionnnaire
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("baseQuestionnaireDataByJob");
        if (storedBase) {
          let data = JSON.parse(storedBase);
          setJobQuestionnaireData(data.data);
        } else {
          try {
            const response = await dispatch(
              fetchQuestionJobData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            );
            setJobQuestionnaireData(response.payload.data);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  // job review
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("jobByReviewData");
        if (storedBase) {
          let data = JSON.parse(storedBase);
          setJobReviewData(data.data);
        } else {
          try {
            const baseResponse = await dispatch(
              fetchReviewListByJobId({
                baseId: Number(baseId),
                jobId: jobId,
              }),
            );
            setJobReviewData(baseResponse.payload.data);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  // job assign
  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem("jobByHiringTeamMembers");
        if (storedBase) {
          let data = JSON.parse(storedBase);
          setJobAssignData(data);
        } else {
          try {
            const baseResponse = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            );
            setJobAssignData(baseResponse.payload.data.teamMembers);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);

  const getUserName = (userId) => {
    // Special case for AI
    if (userId === "ai") {
      return {
        name: "AI",
        profileImage: null,
        isAi: true,
      };
    }

    const user = baseMembers.find(
      (member) =>
        member.user_id === userId || member.user_id === Number(userId),
    );
    if (!user) return null;

    return {
      name: user.name,
      profileImage: user.profile_pic || null,
      isAi: false,
    };
  };

  // Add/remove member from selection
  const toggleAssignee = (member) => {
    setSelectedAssignees((prev) => {
      const isAlreadySelected = prev.some(
        (m) =>
          m.id === member.id ||
          m.user_id === member.user_id ||
          (member.user_id === "ai" && m.user_id === "ai"),
      );

      if (isAlreadySelected) {
        return prev.filter(
          (m) =>
            (m.id !== member.id && m.user_id !== member.user_id) ||
            !(member.user_id === "ai" && m.user_id === "ai"),
        );
      } else {
        return [...prev, member];
      }
    });
  };

  // Remove a specific assignee by ID
  const removeAssignee = (memberId) => {
    setSelectedAssignees((prev) =>
      prev.filter((m) => m.id !== memberId && m.user_id !== memberId),
    );
  };

  // AI Icon Component
  const AiIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      aria-hidden="true"
      data-slot="icon"
      className=" mr-[6px] w-[1rem] h-[1rem] text-[#808080] "
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
      />
    </svg>
  );

  const assignDropdownRef = useRef(null);

  // Add this useEffect to handle click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        assignDropdownRef.current &&
        !assignDropdownRef.current.contains(event.target)
      ) {
        setIsAssignListOpen(false);
      }
    };

    if (isAssignListOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isAssignListOpen]);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => {
        setIsModalOpen(false);
        resetForm();
      }}
      title={editBoardData ? "Edit Job Action" : "Create Job Action"}
      onSave={handleSave}
      loading={loading}
    >
      <form action="#" onSubmit={handleSave} className="space-y-6 mt-5">
        <div className="flex flex-col gap-y-2">
          <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
            Pipeline stages
          </label>
          <div className="flex items-center gap-x-1">
            <div className="relative">
              <Menu as="div" className="flex items-center ">
                <Menu.Button className="px-2 py-[6px] text-sm leading-5 h-[36px] rounded-md border border-gray-300 outline-none">
                  <div
                    className={`h-6 w-6 rounded-full ${color} border flex justify-center items-center`}
                  >
                    <ChevronDownIconWhite />
                  </div>
                </Menu.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-44 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none ">
                    {colorList.map((value, index) => (
                      <div
                        onClick={() => setColor(value.name)}
                        key={index}
                        className={`flex h-6 w-6 border ${value.name} rounded-full m-2 justify-center items-center cursor-pointer `}
                      >
                        {color === value.name && <CustomCheckIcon />}
                      </div>
                    ))}
                  </Menu.Items>
                </Transition>
                {/* <input
                                id='name'
                                name='name'
                                type='text'
                                value={name}
                                onChange={handleInputChange}
                                placeholder='Enter Name'
                                className="w-full px-4 py-2 pl-10 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                            /> */}
              </Menu>
            </div>
            <div className="w-full">
              <Listbox value={selectedStage} onChange={setSelectedStage}>
                <div className="relative mt-0">
                  <ListboxButton className="relative w-full bg-transparent flex items-center justify-between px-2 py-1 h-[36px] cursor-pointer  text-left text-gray-900  rounded-md border border-gray-300 outline-none">
                    <div className="flex items-center gap-x-[6px]">
                      {selectedStage?.stage_colour && (
                        <span
                          className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                          style={{ background: selectedStage.stage_colour }}
                        />
                      )}
                      <span className="block truncate text-[#1b1b1b] font-normal">
                        {selectedStage?.stage_name || "Select Stage"}
                      </span>
                    </div>
                    <span className="pointer-events-none flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="w-[1rem] h-[1rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M6 9l6 6l6 -6" />
                      </svg>
                    </span>
                  </ListboxButton>

                  <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <ListboxOptions className="absolute z-10 mt-[9px] left-[-0px] bg-white max-w-[430px] min-w-[430px] w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                      {optionsWithAllStagesHeader.length > 0 ? (
                        optionsWithAllStagesHeader.map((option) => (
                          <ListboxOption
                            key={option.id}
                            value={option}
                            className={({ active }) =>
                              classNames(
                                active
                                  ? "bg-gray-200 text-[#1d2025]"
                                  : "text-gray-900",
                                "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                              )
                            }
                          >
                            {({ selected, active }) => (
                              <>
                                <div className="flex items-center justify-between w-full">
                                  <div className="flex items-center gap-x-[6px]">
                                    <span
                                      className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                                      style={{
                                        background: option?.stage_colour,
                                      }}
                                    />
                                    <span
                                      className={classNames(
                                        selected
                                          ? "font-semibold"
                                          : "font-normal",
                                        "block truncate",
                                      )}
                                    >
                                      {option.stage_name}
                                    </span>
                                  </div>
                                </div>
                              </>
                            )}
                          </ListboxOption>
                        ))
                      ) : (
                        <div className="px-4 py-2 text-sm text-gray-500">
                          No pipeline stages available
                        </div>
                      )}
                    </ListboxOptions>
                  </Transition>
                </div>
              </Listbox>
            </div>
          </div>

          {/* {nameError && <p className="text-sm text-red-600">{nameError}</p>} */}

          <div className="flex flex-col gap-y-2">
            <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
              Action Type
            </label>
            <Listbox value={selectedJobType} onChange={setSelectedJobType}>
              <div className="relative mt-[-6px]">
                <ListboxButton className="relative w-full bg-transparent flex items-center justify-between px-3 py-2 h-[36px] cursor-pointer text-left text-gray-900 rounded-md border border-gray-300 outline-none">
                  <span className="block truncate text-[#1b1b1b] font-normal capitalize">
                    {selectedJobType?.name || "Select Job Type"}
                  </span>
                  <span className="pointer-events-none flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-[1rem] h-[1rem] text-[#808080]"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M6 9l6 6l6 -6" />
                    </svg>
                  </span>
                </ListboxButton>

                <Transition
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <ListboxOptions className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                    {jobTypeOptions.map((option) => (
                      <ListboxOption
                        key={option.id}
                        value={option}
                        className={({ active }) =>
                          classNames(
                            active
                              ? "bg-gray-200 text-[#1d2025]"
                              : "text-gray-900",
                            "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                          )
                        }
                      >
                        {({ selected, active }) => (
                          <>
                            <span
                              className={classNames(
                                selected ? "font-semibold" : "font-normal",
                                "block truncate capitalize",
                              )}
                            >
                              {option.name}
                            </span>
                            {/* {selected && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-5 w-5 ml-auto"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )} */}
                          </>
                        )}
                      </ListboxOption>
                    ))}
                  </ListboxOptions>
                </Transition>
              </div>
            </Listbox>
          </div>

          {selectedJobType.name === "scorecard" && (
            <div className="flex flex-col gap-y-2">
              <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                Scorecard
              </label>
              <div className=" w-full mt-[-6px]">
                <Listbox
                  value={selectedScoreCard}
                  onChange={setSelectedScoreCard}
                >
                  <div className="relative mt-0">
                    <ListboxButton className="relative w-full bg-transparent flex items-center justify-between px-2 py-1 h-[36px] cursor-pointer  text-left text-gray-900  rounded-md border border-gray-300 outline-none">
                      <div className="flex items-center gap-x-[6px]">
                        {selectedScoreCard?.scorecard_colour && (
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{
                              background: selectedScoreCard.scorecard_colour,
                            }}
                          />
                        )}
                        <span className="block truncate text-[#1b1b1b] font-normal">
                          {selectedScoreCard?.scorecard_name ||
                            "Select Scorecard"}
                        </span>
                      </div>
                      <span className="pointer-events-none flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="w-[1rem] h-[1rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M6 9l6 6l6 -6" />
                        </svg>
                      </span>
                    </ListboxButton>

                    <Transition
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <ListboxOptions className="absolute z-10 mt-[9px] left-[-0px] bg-white  w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                        {optionsWithAllScoreCardHeader.length > 0 ? (
                          optionsWithAllScoreCardHeader.map((option) => (
                            <ListboxOption
                              key={option.id}
                              value={option}
                              className={({ active }) =>
                                classNames(
                                  active
                                    ? "bg-gray-200 text-[#1d2025]"
                                    : "text-gray-900",
                                  "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                )
                              }
                            >
                              {({ selected, active }) => (
                                <>
                                  <div className="flex items-center justify-between w-full">
                                    <div className="flex items-center gap-x-[6px]">
                                      <span
                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                                        style={{
                                          background: option?.scorecard_colour,
                                        }}
                                      />
                                      <span
                                        className={classNames(
                                          selected
                                            ? "font-semibold"
                                            : "font-normal",
                                          "block truncate",
                                        )}
                                      >
                                        {option.scorecard_name}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )}
                            </ListboxOption>
                          ))
                        ) : (
                          <div className="px-4 py-2 text-sm text-gray-500">
                            No pipeline stages available
                          </div>
                        )}
                      </ListboxOptions>
                    </Transition>
                  </div>
                </Listbox>
              </div>
            </div>
          )}

          {/* questionnaire */}
          {selectedJobType.name === "questionnaire" && (
            <div className="flex flex-col gap-y-2">
              <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                Questionnaire
              </label>
              <div className=" w-full mt-[-6px]">
                <Listbox
                  value={selectedQuestionnaire}
                  onChange={setSelectedQuestionnaire}
                >
                  <div className="relative mt-0">
                    <ListboxButton className="relative w-full bg-transparent flex items-center justify-between px-2 py-1 h-[36px] cursor-pointer  text-left text-gray-900  rounded-md border border-gray-300 outline-none">
                      <div className="flex items-center gap-x-[6px]">
                        {selectedQuestionnaire?.questionset_colour && (
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{
                              background:
                                selectedQuestionnaire.questionset_colour,
                            }}
                          />
                        )}
                        <span className="block truncate text-[#1b1b1b] font-normal">
                          {selectedQuestionnaire?.questionset_name ||
                            "Select Questionnaire"}
                        </span>
                      </div>
                      <span className="pointer-events-none flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="w-[1rem] h-[1rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M6 9l6 6l6 -6" />
                        </svg>
                      </span>
                    </ListboxButton>

                    <Transition
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <ListboxOptions className="absolute z-10 mt-[9px] left-[-0px] bg-white  w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                        {optionsWithAllQuestionnaireHeader.length > 0 ? (
                          optionsWithAllQuestionnaireHeader.map((option) => (
                            <ListboxOption
                              key={option.id}
                              value={option}
                              className={({ active }) =>
                                classNames(
                                  active
                                    ? "bg-gray-200 text-[#1d2025]"
                                    : "text-gray-900",
                                  "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                )
                              }
                            >
                              {({ selected, active }) => (
                                <>
                                  <div className="flex items-center justify-between w-full">
                                    <div className="flex items-center gap-x-[6px]">
                                      <span
                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                                        style={{
                                          background:
                                            option?.questionset_colour,
                                        }}
                                      />
                                      <span
                                        className={classNames(
                                          selected
                                            ? "font-semibold"
                                            : "font-normal",
                                          "block truncate",
                                        )}
                                      >
                                        {option.questionset_name}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )}
                            </ListboxOption>
                          ))
                        ) : (
                          <div className="px-4 py-2 text-sm text-gray-500">
                            No Questionnaire available
                          </div>
                        )}
                      </ListboxOptions>
                    </Transition>
                  </div>
                </Listbox>
              </div>
            </div>
          )}

          {/* review */}
          {selectedJobType.name === "review" && (
            <div className="flex flex-col gap-y-2">
              <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
                Review
              </label>
              <div className=" w-full mt-[-6px]">
                <Listbox value={selectedReview} onChange={setSelectedReview}>
                  <div className="relative mt-0">
                    <ListboxButton className="relative w-full bg-transparent flex items-center justify-between px-2 py-1 h-[36px] cursor-pointer  text-left text-gray-900  rounded-md border border-gray-300 outline-none">
                      <div className="flex items-center gap-x-[6px]">
                        {selectedReview?.colour && (
                          <span
                            className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                            style={{ background: selectedReview.colour }}
                          />
                        )}
                        <span className="block truncate text-[#1b1b1b] font-normal">
                          {selectedReview?.review_name || "Select Review"}
                        </span>
                      </div>
                      <span className="pointer-events-none flex items-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="w-[1rem] h-[1rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M6 9l6 6l6 -6" />
                        </svg>
                      </span>
                    </ListboxButton>

                    <Transition
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <ListboxOptions className="absolute z-10 mt-[9px] left-[-0px] bg-white  w-full overflow-hidden rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
                        {optionsWithAllReviewHeader.length > 0 ? (
                          optionsWithAllReviewHeader.map((option) => (
                            <ListboxOption
                              key={option.id}
                              value={option}
                              className={({ active }) =>
                                classNames(
                                  active
                                    ? "bg-gray-200 text-[#1d2025]"
                                    : "text-gray-900",
                                  "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 cursor-pointer",
                                )
                              }
                            >
                              {({ selected, active }) => (
                                <>
                                  <div className="flex items-center justify-between w-full">
                                    <div className="flex items-center gap-x-[6px]">
                                      <span
                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] border-none text-[0.625rem] font-medium text-white capitalize"
                                        style={{ background: option?.colour }}
                                      />
                                      <span
                                        className={classNames(
                                          selected
                                            ? "font-semibold"
                                            : "font-normal",
                                          "block truncate",
                                        )}
                                      >
                                        {option.review_name}
                                      </span>
                                    </div>
                                  </div>
                                </>
                              )}
                            </ListboxOption>
                          ))
                        ) : (
                          <div className="px-4 py-2 text-sm text-gray-500">
                            No review available
                          </div>
                        )}
                      </ListboxOptions>
                    </Transition>
                  </div>
                </Listbox>
              </div>
            </div>
          )}

          {/* assign memebers */}

          {/* assign members - Now multi-select with chips */}
          <div className="flex flex-col gap-y-2">
            <label className="wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6">
              Assign Members
            </label>
            <div className="w-full mt-[-6px]">
              <div className="relative" ref={assignDropdownRef}>
                {/* Chips display area */}
                <div
                  className={`relative w-full bg-transparent flex flex-wrap items-center gap-2 px-2 py-1 min-h-[36px] cursor-pointer text-left text-gray-900 rounded-md border border-gray-300 outline-none ${isAssignListOpen ? "ring-2 ring-blue-500" : ""}`}
                  onClick={() => setIsAssignListOpen(!isAssignListOpen)}
                >
                  {selectedAssignees.length > 0 ? (
                    selectedAssignees.map((assignee) => {
                      const memberDetails = getUserName(assignee.user_id);
                      if (!memberDetails) return null;

                      return (
                        <div
                          key={assignee.id || assignee.user_id}
                          className="flex items-center gap-x-1 bg-gray-100 rounded-md py-1 px-2 text-sm"
                        >
                          {assignee.user_id === "ai" || assignee.is_ai ? (
                            <AiIcon />
                          ) : memberDetails.profileImage ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/${memberDetails.profileImage}`}
                              alt={memberDetails.name}
                              className="h-4 w-4 rounded-full object-cover"
                            />
                          ) : (
                            <div className="h-4 w-4 rounded-full bg-gray-300 flex items-center justify-center text-xs text-gray-600">
                              {memberDetails.name.charAt(0).toUpperCase()}
                            </div>
                          )}
                          <span className="text-xs">{memberDetails.name}</span>
                          <button
                            type="button"
                            className="ml-1 text-gray-400 hover:text-gray-600"
                            onClick={(e) => {
                              e.stopPropagation();
                              removeAssignee(assignee.id || assignee.user_id);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="12"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M18 6L6 18M6 6l12 12" />
                            </svg>
                          </button>
                        </div>
                      );
                    })
                  ) : (
                    <span className="block truncate text-[#1b1b1b] font-normal">
                      Select Team Members
                    </span>
                  )}

                  <span className="absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-[1rem] h-[1rem] text-[#808080]"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M6 9l6 6l6 -6" />
                    </svg>
                  </span>
                </div>

                {/* Dropdown for member selection */}
                {isAssignListOpen && (
                  <div className="absolute z-10 mt-[9px] left-[-0px] bg-white w-full overflow-auto max-h-60 rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5">
                    {optionsWithAllAssignHeader.length > 0 ? (
                      optionsWithAllAssignHeader.map((option) => {
                        // Special handling for AI option
                        if (option.user_id === "ai" || option.is_ai) {
                          const isSelected = selectedAssignees.some(
                            (a) => a.user_id === "ai" || a.is_ai,
                          );
                          return (
                            <div
                              key="ai-option"
                              className={classNames(
                                isSelected
                                  ? "bg-gray-100 text-[#1d2025]"
                                  : "text-gray-900 hover:bg-gray-200",
                                "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground cursor-pointer",
                              )}
                              onClick={() => toggleAssignee(option)}
                            >
                              <div className="flex items-center justify-between w-full">
                                <div className="flex items-center gap-x-[6px]">
                                  <AiIcon />
                                  <span
                                    className={classNames(
                                      isSelected
                                        ? "font-semibold"
                                        : "font-normal",
                                      "block truncate",
                                    )}
                                  >
                                    AI
                                  </span>
                                </div>

                                {isSelected && (
                                  <svg
                                    className="h-4 w-4 text-blue-500"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                )}
                              </div>
                            </div>
                          );
                        }

                        const reviewerName = getUserName(option.user_id);
                        if (!reviewerName) return null;

                        const isSelected = selectedAssignees.some(
                          (a) =>
                            a.id === option.id || a.user_id === option.user_id,
                        );

                        return (
                          <div
                            key={option.id}
                            className={classNames(
                              isSelected
                                ? "bg-gray-100 text-[#1d2025]"
                                : "text-gray-900 hover:bg-gray-200",
                              "relative flex select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground cursor-pointer",
                            )}
                            onClick={() => toggleAssignee(option)}
                          >
                            <div className="flex items-center justify-between w-full">
                              <div className="flex items-center gap-x-[6px]">
                                {reviewerName?.profileImage ? (
                                  <img
                                    src={`${process.env.REACT_APP_API_BASE_URL}/${reviewerName.profileImage}`}
                                    alt={reviewerName.name}
                                    className="h-5 w-5 rounded-full object-cover"
                                  />
                                ) : (
                                  <div className="h-5 w-5 rounded-full bg-gray-300 flex items-center justify-center text-xs text-gray-600">
                                    {reviewerName.name.charAt(0).toUpperCase()}
                                  </div>
                                )}
                                <span
                                  className={classNames(
                                    isSelected
                                      ? "font-semibold"
                                      : "font-normal",
                                    "block truncate",
                                  )}
                                >
                                  {reviewerName.name || option.name}
                                </span>
                              </div>

                              {isSelected && (
                                <svg
                                  className="h-4 w-4 text-blue-500"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="px-4 py-2 text-sm text-gray-500">
                        No team members available
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* <div className='flex flex-col gap-y-2 mt-1'>
            <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6'>Description</label>
            <input
              id="purpose"
              name='purpose'
              type='text'
              value={purpose}
              onChange={handleInputChange}
              placeholder="Team description"
              className="w-full px-4 py-2 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
            />
            {purposeError && <p className="text-sm text-red-600">{purposeError}</p>}
          </div>

          <div className='flex flex-col gap-y-2 mt-1'>
            <label className='wg-label inline-flex cursor-pointer items-center gap-1 text-sm font-medium leading-6'>Description</label>
            <input
              id="purpose"
              name='purpose'
              type='text'
              value={purpose}
              onChange={handleInputChange}
              placeholder="Team description"
              className="w-full px-4 py-2 text-sm leading-6 rounded-md border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
            />
            {purposeError && <p className="text-sm text-red-600">{purposeError}</p>}
          </div> */}
        </div>
      </form>
    </Modal>
  );
};

export default CreateJobActionCard;
